import { Component, OnDestroy } from '@angular/core';
import { PlatformLinkService } from '../../../../../services/platform-link.service';
import { Subscription } from 'rxjs';
import { ModalComponent } from '../../../../../models/modal-component';
import {
    PlatformLinkCopiedConfirmationComponent
} from '../../../../utils/platform-link-copied-confirmation/platform-link-copied-confirmation.component';

@Component({
    selector: 'app-platform-link-copied-confirmation-modal',
    templateUrl: './platform-link-copied-confirmation-modal.component.html',
    styleUrls: ['./platform-link-copied-confirmation-modal.component.scss'],
    imports: [
        PlatformLinkCopiedConfirmationComponent
    ],
    standalone: true
})
export class PlatformLinkCopiedConfirmationModalComponent extends ModalComponent implements OnDestroy {
    static MODAL_ID = 'platformLinkCopyConfirmationModal';

    platformLink: {
        platformName: string;
        logoURL: string;
        heading: string;
        description: string;
    };

    private readonly subscription: Subscription;

    constructor(private platformLinkService: PlatformLinkService) {
        super();
        this.subscription = this.platformLinkService.platformLink$.subscribe(link => {
            this.platformLink = link;
        });
    }

    getId(): string {
        return PlatformLinkCopiedConfirmationModalComponent.MODAL_ID;
    }

    /**
     * called when modal is closed
     */
    onModalClose(): void {
        this.platformLink = undefined;
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

}
